import { improvedFetch2 } from "../../components/fetch";
import { FetchError } from "../errors";

import { Department } from "./types";

export const getAllDepartments: () => Promise<Department[]> = () =>
  improvedFetch2(`/2/geographies/departments`).then(res => {
    if (!res.ok) {
      throw new FetchError();
    }
    return res.json();
  });
